/**
 * Copy + strings used by AccountBillingTab. Kept separate so the component file
 * stays focused on layout/state.
 */

export const ACCOUNT_BILLING_TAB_COPY = {
  CUSTOM_FORM_NAME_EMAIL_REQUIRED: 'Name and email are required.',
  CUSTOM_FORM_SEND_FAILURE: 'Could not send. Please try again.',
} as const
